import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { LOGOS, DISCORD_URL } from "../lib/api";
import { Menu, X, ExternalLink } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/rules", label: "Rules" },
  { to: "/teams", label: "Teams" },
  { to: "/standings", label: "Standings" },
  { to: "/bracket", label: "Bracket" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const loc = useLocation();
  React.useEffect(() => setOpen(false), [loc.pathname]);

  const linkClass = ({ isActive }) =>
    `relative font-display uppercase text-sm tracking-[0.18em] px-3 py-2 transition-colors ${
      isActive
        ? "text-[#FF5E00]"
        : "text-white/80 hover:text-white"
    }`;

  return (
    <header
      className="sticky top-0 z-40 border-b border-[#9D4CDD]/25 backdrop-blur-xl bg-[#0a0512]/80"
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-3 group" data-testid="nav-logo">
          <img
            src={LOGOS.icon}
            alt="EliteGorillaTag"
            className="h-10 w-10 transition-transform group-hover:scale-110 drop-shadow-[0_0_12px_rgba(255,94,0,0.55)]"
          />
          <div className="leading-tight">
            <div className="font-display font-black text-base tracking-wider">
              <span className="text-gradient-orange">ELITE</span>
              <span className="text-white">GORILLA</span>
            </div>
            <div className="font-display text-[10px] uppercase tracking-[0.4em] text-[#9D4CDD]">
              Tag Tournament
            </div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={linkClass}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
            >
              {l.label}
            </NavLink>
          ))}
          <a
            href={DISCORD_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="ml-2 inline-flex items-center gap-2 font-display uppercase text-xs tracking-[0.18em] px-4 py-2 rounded-md bg-[#5865F2] text-white hover:bg-[#4752C4] transition-all"
            data-testid="nav-link-discord"
          >
            Discord <ExternalLink className="w-3 h-3" />
          </a>
          <NavLink
            to="/admin"
            className="ml-2 font-display uppercase text-xs tracking-[0.18em] px-4 py-2 rounded-md border border-[#9D4CDD]/60 text-white hover:border-[#FF5E00] hover:text-[#FF5E00] transition-all"
            data-testid="nav-link-admin"
          >
            Admin
          </NavLink>
        </nav>

        <button
          aria-label="Toggle menu"
          className="lg:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#9D4CDD]/20 bg-[#0a0512]/95">
          <div className="px-4 py-3 flex flex-col">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                className={linkClass}
                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </NavLink>
            ))}
            <a
              href={DISCORD_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 font-display uppercase text-sm tracking-[0.18em] px-3 py-2 rounded-md bg-[#5865F2] text-white text-center"
              data-testid="mobile-nav-discord"
            >
              Join Discord
            </a>
            <NavLink
              to="/admin"
              className="mt-2 font-display uppercase text-sm tracking-[0.18em] px-3 py-2 rounded-md border border-[#9D4CDD]/60 text-white text-center"
              data-testid="mobile-nav-admin"
            >
              Admin
            </NavLink>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
